<template>
    <div>
        <nav class="navbar navbar-default" :style="backgroundColor">
            <div class="container-fluid">
                <!-- Brand and toggle get grouped for better mobile display -->
                <div class="navbar-header">
                    <router-link class="navbar-brand" :to="{ name: 'dashboard' }" :style="fontColor">
                        {{ appName }}
                    </router-link>
                </div>

                <!-- Collect the nav links, forms, and other content for toggling -->
                <div id="bs-example-navbar-collapse-1">

                    <form class="navbar-form-custom navbar-form navbar-left hide">
                        <div class="form-group">
                            <i class="icon fa fa-search" aria-hidden="true"></i>
                            <input type="text" class="form-control" placeholder="Search">
                        </div>
                    </form>

                    <ul class="nav navbar-nav navbar-right">
                        <li v-if="user" class="user-action dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button"
                               aria-haspopup="true"
                               aria-expanded="false" :style="fontColor"
                            >
                            <span class="user-avatar">
                                <img :src="user.profile_photo_large ? user.profile_photo_large : '/static/images/blank-profile-picture.png'"
                                     alt="">
                            </span>
                                <span class="name">
                                Hello, {{ user.first_name }}
                            </span>
                            </a>
                            <ul class="dropdown-menu">
                                <li><a :href="profileLink" target="_blank">Profile</a></li>
                                <li><a href="#" @click.prevent="logout">Logout</a></li>
                            </ul>
                        </li>

                        <router-link v-else :to="{ name: 'login' }" tag="li">
                            <a>
                                <i class="fa fa-user"></i>
                                Login
                            </a>
                        </router-link>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
    // import name from 'name'

    export default {
        name: 'Header',
        props: ['user'],
        data() {
            return {
                backgroundColor: null,
                fontColor: null,
                appName: window.APP_NAME
            }
        },
        computed: {
            profileLink() {
                return window.API_DOMAIN + '/profiles/' + this.user.id
            }
        },
        watch: {
            '$route.params'() {
                if (! this.$route.params.entity_id) {
                    this.backgroundColor = null;
                    this.fontColor = null;
                }
            }
        },
        methods: {
            logout() {
                Event.$emit('userLoggedOutAction', this.$route);
            }
        },
        mounted() {

            /**
             * Update header colors when an entity says so.
             */
            Event.$on('update-header-color', (backgroundColorCode, fontColorCode) => {
                this.backgroundColor = {
                    backgroundColor: backgroundColorCode
                };

                this.fontColor = {
                    color: fontColorCode
                };
            })
        }
    }
</script>

<style lang="sass" rel="stylesheet">
    @media (max-width: 767px)
        .user-action
            .dropdown-toggle
                position: absolute
                top: -55px
                right: 5px

                .user-avatar
                    position: relative

                    &:after
                        content: "\f0d7"
                        font-family: FontAwesome
                        position: absolute
                        right: -12px
                        top: 0
                        color: #fff

                .name
                    display: none
</style>


// WEBPACK FOOTER //
// Header.vue?6491f08e